/** @format */

import React from "react";
import Moment from "react-moment";
import { dateFormat } from "./GlobalVariables";

export default function MomentDate({ getDate }) {
  return <Moment format={dateFormat}>{getDate}</Moment>;
}
